import SmartLoading from '@/pages/components/common/SmartLoading'
import Loadable from 'react-loadable'

export default [
  // 滑块组件 给app端用
  {
    path: '/courierView/commonSmartCaptcha',
    component: Loadable({
      loader: () => import('@/pages/components/commonSmartCaptcha'),
      loading: SmartLoading
    }),
    meta: {
      title: '滑块验证码'
    }
  }
]
